class Option {
    static pageRoute = 'route';
    static targetPageRoute = 'product/product';
    static optionsWrap = '[data-price-options]';
    static targetOption = 'input[data-price]:checked';
    static wrapOptionId = '[data-price-option-id]';
    static requiredOption = '[data-required-option]';

    /** @return {{}|{number:[number]}} */
    static get() {
        const inputRoute = document.getElementById(Option.pageRoute);
        const list = [];

        if (inputRoute && inputRoute.value === Option.targetPageRoute) {
            let modal = document.getElementById('commonModal');

            const wrap = modal && modal.getAttribute('aria-hidden') === 'false' ?
                modal : document.querySelector(`.price-info ${Option.optionsWrap}`);

            if (!wrap) {
                return list;
            }

            const sections = wrap.querySelectorAll(Option.wrapOptionId);

            for (let section of sections) {
                const optionId = parseInt(section.dataset.priceOptionId, 10);

                if (optionId) {
                    const elements = wrap.querySelectorAll(Option.targetOption);
                    const items = [];

                    for (let elem of elements) {
                        const val = parseInt(elem.value, 10);

                        if (val) {
                            items.push(val);
                        }
                    }

                    if (items.length) {
                        const item = {};
                        item[optionId] = items;
                        list.push(item);
                    }
                }
            }
        }

        return list;
    }

    /** @return {boolean} */
    static showPopup() {
        const inputRoute = document.getElementById(Option.pageRoute);

        if (inputRoute && inputRoute.value === Option.targetPageRoute) {
            const findRequiredElem = document.querySelector(`${Option.optionsWrap} ${Option.requiredOption}`);

            if (!findRequiredElem) {
                return false;
            }

            const findItem = parseInt(findRequiredElem.dataset.requiredOption, 10);

            if (findItem) {
                const elements = document.querySelectorAll(`${Option.optionsWrap} ${Option.targetOption}`);

                return !elements.length;
            }
        }

        return false;
    }
}

export default Option;
